import React from "react";
import DeviceLocationMap from "./DeviceLocationMap";
import Footer from "../../components/common/Footer";
import { Box } from "@mui/material";
const VehicleTracker = () => {
  return (
    <>
      <DeviceLocationMap />
      <Footer />
    </>
  );
};

export default VehicleTracker;
